// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rEufM{display:flex;flex-direction:column;gap:30px}.kLpeZ{border-radius:10px;padding:5px}.JeNq2{display:flex;flex-direction:column;gap:10px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentWrapper": `rEufM`,
	"calloutWrapper": `kLpeZ`,
	"richTextEditorWrapper": `JeNq2`
};
export default ___CSS_LOADER_EXPORT___;
